import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blue_box _full" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "checkbox_wrap sch_list" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "_flex _align_bottom _multi" }
const _hoisted_8 = { class: "select_tab_box_wrap" }
const _hoisted_9 = { class: "select_tab_box _130" }
const _hoisted_10 = { class: "tab_option" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "select_tab_box_wrap" }
const _hoisted_13 = { class: "select_tab_box _130" }
const _hoisted_14 = { class: "tab_option" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "select_date_wrap" }
const _hoisted_17 = { class: "select_date" }
const _hoisted_18 = { class: "select_date" }
const _hoisted_19 = { class: "search_wrap" }
const _hoisted_20 = { class: "right _align_bottom _flex" }
const _hoisted_21 = { class: "common_table custom_scroll" }
const _hoisted_22 = { class: "underline" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "ellipsis_1 underline" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "p_5" }
const _hoisted_27 = { class: "cnt" }
const _hoisted_28 = { class: "cnt" }
const _hoisted_29 = { class: "cnt" }
const _hoisted_30 = { class: "cnt" }
const _hoisted_31 = { class: "cnt" }
const _hoisted_32 = { class: "cnt" }
const _hoisted_33 = { class: "cnt" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "cnt checkbox_wrap _plus" }
const _hoisted_37 = ["for"]
const _hoisted_38 = ["id", "checked", "onClick"]
const _hoisted_39 = { class: "cnt p_5" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!
  const _component_EventModal = _resolveComponent("EventModal")!
  const _component_NewsModal = _resolveComponent("NewsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "box_tit _flex" }, [
          _createElementVNode("h2", null, "시민참여활동")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: "all",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.selectedType) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleAllRole && $setup.toggleAllRole(...args)))
                }, null, 544), [
                  [_vModelCheckbox, $setup.state.selectedType]
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("em", null, null, -1)),
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "전체", -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.type_list, (item) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: item.key
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: item.key,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.selectedType) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleRoleChange && $setup.handleRoleChange(...args)))
                  }, null, 40, _hoisted_6), [
                    [_vModelCheckbox, $setup.state.selectedType]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("em", null, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sch_list_tit" }, "진행상태", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["selected_tab", [$setup.state.isShowState ? 'active' : '']]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.state.isShowState = !$setup.state.isShowState))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($setup.state.searchStateType), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state_list, (item) => {
                      return (_openBlock(), _createElementBlock("button", {
                        onClick: ($event: any) => {
                                            $setup.state.searchState = item.key;
                                            $setup.state.searchStateType = item.value;
                                            $setup.state.isShowState = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        }
                      }, _toDisplayString(item.value), 9, _hoisted_11))
                    }), 256))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "sch_list_tit" }, "선발상태", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["selected_tab", [$setup.state.isShowApplyState ? 'active' : '']]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.isShowApplyState = !$setup.state.isShowApplyState))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($setup.state.searchApplyStateType), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.apply_state_list, (item) => {
                      return (_openBlock(), _createElementBlock("button", {
                        onClick: ($event: any) => {
                                            $setup.state.searchApplyState = item.key;
                                            $setup.state.searchApplyStateType = item.value;
                                            $setup.state.isShowApplyState = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        }
                      }, _toDisplayString(item.value), 9, _hoisted_15))
                    }), 256))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form_state.startDate) = $event)),
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin-left":"5px"},
                    type: "date",
                    onKeydown: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.endDate) = $event)),
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.endDate]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.searchText) = $event)),
                  onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => {
                                    $setup.state.page = 1;
                                    $setup.getList();
                                }, ["enter"])),
                  placeholder: "제목을 입력하세요."
                }, null, 544), [
                  [_vModelText, $setup.state.searchText]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "search_btn icon_wrap",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {
                                    $setup.state.page = 1;
                                    $setup.getList();
                                })
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("img", {
                    src: "img/search_btn.png",
                    alt: ""
                  }, null, -1)
                ]))])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "default_btn _blue",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.addActivity && $setup.addActivity(...args)))
            }, "반성매매 시민활동 등록"),
            _createElementVNode("button", {
              type: "button",
              class: "default_btn _blue",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.addEvent && $setup.addEvent(...args)))
            }, "캠페인·이벤트 등록"),
            _createElementVNode("button", {
              type: "button",
              class: "default_btn _blue",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.addNews && $setup.addNews(...args)))
            }, "감시뉴스 등록")
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("table", null, [
            _cache[33] || (_cache[33] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"140px"} }),
              _createElementVNode("col"),
              _createElementVNode("col", { style: {"width":"80px"} }),
              _createElementVNode("col", { style: {"width":"120px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"70px"} }),
              _createElementVNode("col", { style: {"width":"70px"} }),
              _createElementVNode("col", { style: {"width":"70px"} }),
              _createElementVNode("col", { style: {"width":"70px"} })
            ], -1)),
            _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "번호"),
                _createElementVNode("th", null, "게시판 이름"),
                _createElementVNode("th", null, "제목"),
                _createElementVNode("th", null, "조회수"),
                _createElementVNode("th", null, "작성자"),
                _createElementVNode("th", null, "모집 시작일"),
                _createElementVNode("th", null, "모집 종료일"),
                _createElementVNode("th", null, "신청 종료일"),
                _createElementVNode("th", null, "작성일"),
                _createElementVNode("th", null, "진행상태"),
                _createElementVNode("th", null, "선발상태"),
                _createElementVNode("th", null, "썸네일"),
                _createElementVNode("th", null, "메인추가"),
                _createElementVNode("th", null, "수정")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.idx
                    }, [
                      _createElementVNode("td", null, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("a", {
                          href: $setup.state.userSiteUrl + '/#/' + (item.type === 4 ? 'news' : 'board?type=' + +item.type),
                          target: "_blank"
                        }, _toDisplayString($setup.strBoardType(item.type)), 9, _hoisted_23)
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("a", {
                          href: 
                                            $setup.state.userSiteUrl +
                                            '/#/' +
                                            (item.type === 1 ? 'activityView/' : item.type === 2 ? 'eventView/' : 'newsView/') +
                                            item.idx
                                        ,
                          target: "_blank"
                        }, _toDisplayString(item.title), 9, _hoisted_25)
                      ]),
                      _createElementVNode("td", _hoisted_26, _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.writer), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(item.recruitStartDate != null && item.type === 1
                                            ? $setup.CommonUtils.dateFormatYY(new Date(item.recruitStartDate), ".")
                                            : ""), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(item.recruitEndDate != null && item.type === 1
                                            ? $setup.CommonUtils.dateFormatYY(new Date(item.recruitEndDate), ".")
                                            : ""), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(item.applyDate != null ? $setup.CommonUtils.dateFormatYY(new Date(item.applyDate), ".") : ""), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(item.type === 1 ? $setup.strState(item.state) : ""), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(item.type !== 4 ? (item.applyState === 1 ? "완료" : "미완료") : ""), 1),
                      _createElementVNode("td", _hoisted_33, [
                        (item.thumbnail)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "tb_img img_wrap",
                              onClick: ($event: any) => ($setup.viewImage(item.thumbnail))
                            }, [
                              _createElementVNode("img", {
                                src: item.thumbnail,
                                alt: ""
                              }, null, 8, _hoisted_35)
                            ], 8, _hoisted_34))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_36, [
                        _createElementVNode("label", {
                          for: 'chk_' + item.idx,
                          onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk_' + item.idx,
                            checked: item.isMain === 1,
                            onClick: _withModifiers(($event: any) => ($setup.isMain(item.idx)), ["prevent"])
                          }, null, 8, _hoisted_38),
                          _cache[31] || (_cache[31] = _createElementVNode("em", null, null, -1))
                        ], 8, _hoisted_37)
                      ]),
                      _createElementVNode("td", _hoisted_39, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "table_btn _blue",
                          onClick: ($event: any) => ($setup.showModal(item.type, item.idx))
                        }, "수정", 8, _hoisted_40)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_41, [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("td", { colspan: "13" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "데이터가 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              data: $setup.state.data,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "data", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isActivityShowModal)
      ? (_openBlock(), _createBlock(_component_ActivityModal, {
          key: 1,
          data: $setup.state.activityInfo,
          onClose: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.isActivityShowModal = false)),
          onCallback: _cache[20] || (_cache[20] = ($event: any) => {
            $setup.state.isActivityShowModal = false;
            $setup.getList();
        })
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    ($setup.state.isEventShowModal)
      ? (_openBlock(), _createBlock(_component_EventModal, {
          key: 2,
          data: $setup.state.eventInfo,
          onClose: _cache[21] || (_cache[21] = ($event: any) => ($setup.state.isEventShowModal = false)),
          onCallback: _cache[22] || (_cache[22] = ($event: any) => {
            $setup.state.isEventShowModal = false;
            $setup.getList();
        })
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    ($setup.state.isNewsShowModal)
      ? (_openBlock(), _createBlock(_component_NewsModal, {
          key: 3,
          data: $setup.state.newsInfo,
          onCallback: _cache[23] || (_cache[23] = ($event: any) => {
            $setup.state.isNewsShowModal = false;
            $setup.getList();
        }),
          onClose: _cache[24] || (_cache[24] = ($event: any) => ($setup.state.isNewsShowModal = false))
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ], 64))
}